import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useSupportUnreadCount } from "@/hooks/useSupportThreads";
import { cn } from "@/lib/utils";

interface AskNedraButtonProps {
  onClick: () => void;
  className?: string;
}

export function AskNedraButton({ onClick, className }: AskNedraButtonProps) {
  const { data: unreadCount = 0 } = useSupportUnreadCount();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={cn("relative flex items-center gap-2", className)}
    >
      <HelpCircle className="h-5 w-5" />
      <span className="hidden sm:inline">Ask Nedra</span>
      {unreadCount > 0 && (
        <Badge
          variant="destructive"
          className="absolute -top-1 -right-1 h-5 min-w-5 px-1.5 flex items-center justify-center text-xs"
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </Badge>
      )}
    </Button>
  );
}
